export const servicesList = [
    {
      title: "Speed Essentials",
      description:
        "Unlock our vehicle's full racing potential with our special components and services.",
      services: [
        "Exhaust Systems",
        "Air Intake Systems",
        "Chassis Reinforcement",
        "Aerodynamic Upgrades",
        "High-Performance Brake Kits",
      ],
      image: require("../../assets/images/servicesbg1.jpg"),
    },
    {
      title: "Daily Driver Solutions",
      description:
        "Elevate your daily drive with essential services and enhancements.",
      services: [
        "Tire Services",
        "Engine Tune-Ups",
        "Electrical Repairs",
        "Brake Maintenance",
        "Steering & Alignment Services",
      ],
      image: require("../../assets/images/servicesbg2.jpg"),
    },
  ];